'use client';

interface Args {
  eventName: string;
  eventId: string;
  sourceUrl: string;
  email?: string;
  fbp?: string;
  fbc?: string;
  formId?: string;
  formValues?: Record<string, string>;
  customData?: Record<string, string>;
}

export interface ServerEventResult {
  /** Only true when the platform answered that it deliberately did not send. */
  skipped: boolean;
}

/**
 * Sends the server-side event and reports back whether the platform refused to
 * count this submission - a skip condition from the form definition matched.
 * A rejection or a request that never landed is not a refusal: the browser
 * event still has to fire.
 */
export async function sendServerEvent({
  eventName,
  eventId,
  sourceUrl,
  email,
  fbp,
  fbc,
  formId,
  formValues,
  customData,
}: Args): Promise<ServerEventResult> {
  try {
    const response = await fetch('/api/meta-capi', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventName,
        eventId,
        sourceUrl,
        email,
        _fbp: fbp,
        _fbc: fbc,
        formId,
        formValues,
        customData,
      }),
    });

    const result: { sent?: boolean } = await response
      .json()
      .catch(() => ({}) as { sent?: boolean });

    if (!response.ok) {
      console.error('[Meta CAPI] Server-side event rejected:', result);
      return { skipped: false };
    }

    return { skipped: result.sent === false };
  } catch (err) {
    console.error('[Meta CAPI] Failed to send server-side event:', err);
    return { skipped: false };
  }
}
